import { render, staticRenderFns } from "./OwnerPrices.vue?vue&type=template&id=08ee5bc5&"
import script from "./OwnerPrices.vue?vue&type=script&lang=js&"
export * from "./OwnerPrices.vue?vue&type=script&lang=js&"
import style0 from "./OwnerPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports